import axios from 'axios';
import { handleLogout } from '../../utility/utility';
import CryptoJS from 'crypto-js';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const SECRETKEY = 'SKILLED@2024' //process.env.REACT_SECRETKEY;

const client = axios.create({
    baseURL: API_ENDPOINT,
    headers: {
        'Content-Type': 'application/json',
    },
});

client.interceptors.request.use(async(config) => {
    // do something before executing the request
    // For example tag along the bearer access token to request header or set a cookie
    const requestConfig = config;
    const { headers } = config;
    try {
        const response = await axios.get(API_ENDPOINT+'checkCustomerValid')
        requestConfig.headers = { ...headers, Authorization: `Bearer ${response.data.accessToken}` };
        return requestConfig;
    } catch (error) {
        // this failed, so let's redirect to the login page
        handleLogout()
        return Promise.reject(error);
    }
    // requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };
    
});

client.interceptors.response.use(
    response => response,
    error => {
        const { response } = error;
        const originalRequest = error.config;
        if (response) {
            
            if (response.status === 500 || response.status === 401 || response.status === 403) {
                // do something here
                // window.location.href = '/admin';
                // window.location.href = '/'
                // handleLogout()
                return Promise.reject(error);
            } else {
                return originalRequest;
            }
        }
        return Promise.reject(error);
    },
);

class DataService {
    static get(path = '', config = {}) {
        return client({
            method: 'GET',
            url: path,
            headers: {}, // headers: { ...authHeader() },
            ...config,
        });
    }

    static post(path = '', data = {}, optionalHeader = {}) {
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRETKEY).toString();
        return client({
            method: 'POST',
            url: path,
            data: {encryptedData},
            headers: {...optionalHeader },
        });
    }

    static patch(path = '', data = {}) {
        return client({
            method: 'PATCH',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }

    static delete(path = '', data = {}) {
        return client({
            method: 'DELETE',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }

    static put(path = '', data = {}) {
        return client({
            method: 'PUT',
            url: path,
            data: JSON.stringify(data),
            headers: {},
        });
    }
}

export { DataService };